/**
 * Breadcrumb  Functional Component
 * @Package - seo/brandPart
 * @Author - Cybage@UPWA-Team
 * @description: Breadcrumb related to brandPart SEO
 */
/**
 *  BrandPart SEO's Breadcrumb Component
 */
import React from 'react'
import SeoBreadcrumb from '../SeoBreadcrumb'

const trueFlag = true

export default function Breadcrumb({ dynamicApiData }) {
  const hasBreadcrumbData = Boolean(dynamicApiData && Object.keys(dynamicApiData).length)

  if (!hasBreadcrumbData) return ''

  return (
    <SeoBreadcrumb
      id="BrandPartBreadCrumb"
      data={dynamicApiData}
      useLastLinkFlag={trueFlag}
    />
  )
}
